import { registerComponent } from '@gig/magic-common';
import BalanceComponent from './balance.vue.js';

var Balance = registerComponent(BalanceComponent);

export { Balance };
